import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BASE}/api`;

// Admin sessions ride on an httpOnly cookie set by the backend; nothing
// sensitive is kept in localStorage. `withCredentials` makes the browser
// attach that cookie to every /api request.
export const api = axios.create({ baseURL: API, timeout: 120000, withCredentials: true });

export const getList = (name, params = {}) =>
  api.get(`/collections/${name}`, { params }).then((r) => r.data);

export const getItem = (name, slug) =>
  api.get(`/collections/${name}/${slug}`).then((r) => r.data);

export const getHomepage = () => api.get("/homepage").then((r) => r.data);
export const getNav = () => api.get("/nav").then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const search = (q) => api.get("/search", { params: { q } }).then((r) => r.data);
export const suggestDestinations = (q) =>
  api.get("/destinations/suggest", { params: { q } }).then((r) => r.data);
export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const generatePlan = (payload) => api.post("/ai/plan", payload).then((r) => r.data);
export const planPdfUrl = (id) => `${API}/ai/plan/${id}/pdf`;

export const inr = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "";
  return `\u20B9${Number(n).toLocaleString("en-IN")}`;
};

export const waLink = (number, text) =>
  `https://wa.me/${(number || "919810701234").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const destUrl = (d) => `/${d.region || "international"}/${d.slug}`;
